import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import { bindActionCreators } from 'redux'

import ErrorImage from '!base64-image-loader!assets/images/form/error.png'
import { logoutRequest } from 'quick-quote/actions'

import { FullScreenPopup } from './global-popup'

export const _AmloAdvisorError = ({ notificationMessage, logoutRequest, onExit }) => {
  const onClose = () => {
    logoutRequest()
    onExit()
  }
  return <FullScreenPopup onExit={onClose} title="กรุณาลองใหม่ภายหลัง" isOpen={notificationMessage.type !== 'None'}>
    <img src={ErrorImage} alt="error-image" />
    <div className="description">
      <div data-testid="amlo-advisor-error-title">เกิดปัญหาระบบขัดข้อง</div>
      <div className="highlight">กรุณาลองใหม่ภายหลัง</div>
    </div>
    <Button color="primary" onClick={onClose}>
      กลับ
    </Button>
  </FullScreenPopup>
}

const mapDispatchToProps = (dispatch) => ({
  logoutRequest: bindActionCreators(logoutRequest, dispatch),
})

export default connect(null, mapDispatchToProps)(_AmloAdvisorError)
